module.exports = "<div class=\"user-details-component user-external-accounts\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      EXTERNAL ACCOUNTS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"external-accounts-grid\">\r\n      <div id=\"external-accounts-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-external-accounts/user-external-accounts.html
 ** module id = 612
 ** module chunks = 0
 **/